module.exports = __webpack_public_path__ + "img/educationInfo.3e82c6b5.png";